import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import { createRouterLayout } from 'vue-router-layout'

const RouterLayout = createRouterLayout(layout => {
  return import('@/layouts/' + layout + '/' + layout + '.vue')
})

Vue.use(Router)
Vue.use(Meta)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: RouterLayout,
      children: [
        {
          path: 'router',
          name: 'PageTOC',
          //  load sync
          component: require('@/pages/PageTOC/PageTOC').default
        },
        {
          path: '/login',
          name: 'PageLogin',
          //  load dynamic
          component: () => import(/* webpackChunkName: "pagelogin" */ '@/pages/PageLogin/PageLogin')
        },
        {
          path: '/admin/notice',
          name: 'PageNewsList',
          //  load sync
          component: require('@/pages/PageNewsList/PageNewsList').default,
          meta: { requiredAuth: true }
        },
        {
          path: '/admin/notice/add',
          name: 'PageAddNews',
          //  load sync
          component: require('@/pages/PageAddNews/PageAddNews').default,
          meta: { requiredAuth: true }
        },
        {
          path: '/admin/notice/edit/:id',
          name: 'PageEditNews',
          //  load sync
          component: require('@/pages/PageAddNews/PageAddNews').default,
          meta: { requiredAuth: true }
        },
        {
          path: '/result/:historyId',
          name: 'PageResult',
          component: require('@/pages/PageResult/PageResult').default,
          meta: { requiredAuth: true }
        },
        {
          path: '/reservation',
          name: 'PageReservationList',
          //  load sync
          component: require('@/pages/PageReservationList/PageReservationList').default,
          meta: { requiredAuth: true }
        },
        {
          path: '/history',
          name: 'PageHistoryList',
          //  load sync
          component: require('@/pages/PageHistoryList/PageHistoryList').default,
          meta: { requiredAuth: true }
        },
        {
          path: '/bookmarklist',
          name: 'PageBookmarkList',
          //  load sync
          component: require('@/pages/PageBookmarkList/PageBookmarkList').default,
          meta: { requiredAuth: true }
        },
        {
          path: '/analyze/IF00014',
          name: 'PageIF00014',
          //  load dynamic
          component: () => import(/* webpackChunkName: "manual" */ '@/pages/PageIF00014/PageIF00014'),
          meta: { requiredAuth: true }
        },
        {
          path: '/analyze/IF00015',
          name: 'PageIF00015',
          //  load dynamic
          component: () => import(/* webpackChunkName: "manual" */ '@/pages/PageIF00015/PageIF00015'),
          meta: { requiredAuth: true }
        },
        {
          path: '/analyze/:code',
          name: 'PageAnalyze',
          //  load dynamic
          component: () => import(/* webpackChunkName: "pageanalyze" */ '@/pages/PageAnalyze/PageAnalyze'),
          meta: { requiredAuth: true }
        },
        {
          path: '/password',
          name: 'PagePassword',
          //  load dynamic
          component: () => import(/* webpackChunkName: "password" */ '@/pages/PagePassword/PagePassword')
        },
        {
          path: '/password/send',
          name: 'PagePasswordSend',
          //  load dynamic
          component: () => import(/* webpackChunkName: "passwordsend" */ '@/pages/PagePasswordSend/PagePasswordSend')
        },
        {
          path: '/password/input_check/:code',
          name: 'PagePasswordInputCheck',
          //  load dynamic
          component: () => import(/* webpackChunkName: "passwordinputcheck" */ '@/pages/PagePasswordInput/PagePasswordInputCheck')
        },
        {
          path: '/password/input/:code',
          name: 'PagePasswordInput',
          //  load dynamic
          component: () => import(/* webpackChunkName: "passwordinput" */ '@/pages/PagePasswordInput/PagePasswordInput')
        },
        {
          path: '/password/complete',
          name: 'PagePasswordComplete',
          //  load dynamic
          component: () => import(/* webpackChunkName: "passwordcomplete" */ '@/pages/PagePasswordComplete/PagePasswordComplete')
        },
        {
          path: '/setting/change',
          name: 'PageSetting',
          //  load dynamic
          component: () => import(/* webpackChunkName: "setting" */ '@/pages/PageSetting/PageSetting'),
          meta: { requiredAuth: true }
        },
        {
          path: '/group/category',
          name: 'PageCategoryGroupList',
          //  load dynamic
          component: () => import(/* webpackChunkName: "categorygroup" */ '@/pages/PageCategoryGroupList/PageCategoryGroupList'),
          meta: { requiredAuth: true }
        },
        {
          path: '/group/category/add',
          name: 'PageCategoryGroupAdd',
          //  load dynamic
          component: () => import(/* webpackChunkName: "categorygroupadd" */ '@/pages/PageCategoryGroupEdit/PageCategoryGroupEdit'),
          meta: { requiredAuth: true }
        },
        {
          path: '/group/category/edit/:id',
          name: 'PageCategoryGroupEdit',
          //  load dynamic
          component: () => import(/* webpackChunkName: "categorygroupedit" */ '@/pages/PageCategoryGroupEdit/PageCategoryGroupEdit'),
          meta: { requiredAuth: true }
        },
        {
          path: '/group/product',
          name: 'PageProductGroupList',
          //  load dynamic
          component: () => import(/* webpackChunkName: "productgrouplist" */ '@/pages/PageProductGroupList/PageProductGroupList'),
          meta: { requiredAuth: true }
        },
        {
          path: '/group/product/add',
          name: 'PageProductGroupAdd',
          //  load dynamic
          component: () => import(/* webpackChunkName: "productgroupadd" */ '@/pages/PageProductGroupEdit/PageProductGroupEdit'),
          meta: { requiredAuth: true }
        },
        {
          path: '/group/product/edit/:id',
          name: 'PageProductGroupEdit',
          //  load dynamic
          component: () => import(/* webpackChunkName: "productgroupedit" */ '@/pages/PageProductGroupEdit/PageProductGroupEdit'),
          meta: { requiredAuth: true }
        },
        {
          path: '/group/shop',
          name: 'PageShopGroupList',
          //  load dynamic
          component: () => import(/* webpackChunkName: "shopgroup" */ '@/pages/PageShopGroupList/PageShopGroupList'),
          meta: { requiredAuth: true }
        },
        {
          path: '/group/shop/add',
          name: 'PageShopGroupAdd',
          //  load dynamic
          component: () => import(/* webpackChunkName: "shopgroupadd" */ '@/pages/PageShopGroupEdit/PageShopGroupEdit'),
          meta: { requiredAuth: true }
        },
        {
          path: '/group/shop/edit/:id',
          name: 'PageShopGroupEdit',
          //  load dynamic
          component: () => import(/* webpackChunkName: "shopgroupedit" */ '@/pages/PageShopGroupEdit/PageShopGroupEdit'),
          meta: { requiredAuth: true }
        },
        {
          path: '/group/member',
          name: 'PageMemberGroupList',
          //  load dynamic
          component: () => import(/* webpackChunkName: "membergroup" */ '@/pages/PageMemberGroupList/PageMemberGroupList'),
          meta: { requiredAuth: true }
        },
        {
          path: '/group/member/add',
          name: 'PageMemberGroupAdd',
          //  load dynamic
          component: () => import(/* webpackChunkName: "pageanalyze" */ '@/pages/PageAnalyze/PageAnalyze'),
          meta: { requiredAuth: true }
        },
        {
          path: '/group/member/edit/:id',
          name: 'PageMemberGroupEdit',
          //  load dynamic
          component: () => import(/* webpackChunkName: "pageanalyze" */ '@/pages/PageAnalyze/PageAnalyze'),
          meta: { requiredAuth: true }
        },
        {
          path: '/attribute',
          name: 'PageProductAttribute',
          //  load dynamic
          component: () => import(/* webpackChunkName: "productattribute" */ '@/pages/PageProductAttribute/PageProductAttribute'),
          meta: { requiredAuth: true }
        },
        {
          path: '/admin/user',
          name: 'PageUserList',
          //  load dynamic
          component: () => import(/* webpackChunkName: "userlist" */ '@/pages/PageUserList/PageUserList'),
          meta: { requiredAuth: true }
        },
        {
          path: '/admin/user/add',
          name: 'PageUserAdd',
          //  load dynamic
          component: () => import(/* webpackChunkName: "useradd" */ '@/pages/PageUserEdit/PageUserEdit'),
          meta: { requiredAuth: true }
        },
        {
          path: '/admin/user/edit/:id',
          name: 'PageUserEdit',
          //  load dynamic
          component: () => import(/* webpackChunkName: "useredit" */ '@/pages/PageUserEdit/PageUserEdit'),
          meta: { requiredAuth: true }
        },
        {
          path: '/admin/maker',
          name: 'PageContractList',
          //  load dynamic
          component: () => import(/* webpackChunkName: "contractlist" */ '@/pages/PageContractList/PageContractList'),
          meta: { requiredAuth: true }
        },
        {
          path: '/admin/contract/add',
          name: 'PageContractAdd',
          //  load dynamic
          component: () => import(/* webpackChunkName: "contractadd" */ '@/pages/PageContractEdit/PageContractEdit'),
          meta: { requiredAuth: true }
        },
        {
          path: '/admin/contract/edit/:id',
          name: 'PageContractEdit',
          //  load dynamic
          component: () => import(/* webpackChunkName: "contractedit" */ '@/pages/PageContractEdit/PageContractEdit'),
          meta: { requiredAuth: true }
        },
        {
          path: '/admin/maker/add',
          name: 'PageMakerAdd',
          //  load dynamic
          component: () => import(/* webpackChunkName: "contractadd" */ '@/pages/PageContractEdit/PageContractEdit'),
          meta: { requiredAuth: true }
        },
        {
          path: '/admin/maker/edit/:id',
          name: 'PageMakerEdit',
          //  load dynamic
          component: () => import(/* webpackChunkName: "contractedit" */ '@/pages/PageContractEdit/PageContractEdit'),
          meta: { requiredAuth: true }
        },
        {
          path: '/dashboard',
          name: 'PageDashboard',
          //  load dynamic
          component: () => import(/* webpackChunkName: "dashboard" */ '@/pages/PageDashboard/PageDashboard'),
          meta: { requiredAuth: true }
        },
        {
          path: '/',
          name: 'PageIndex',
          //  load dynamic
          component: () => import(/* webpackChunkName: "dashboard" */ '@/pages/PageDashboard/PageDashboard'),
          meta: { requiredAuth: true }
        },
        {
          path: '/manual',
          name: 'PageManual',
          //  load dynamic
          component: () => import(/* webpackChunkName: "manual" */ '@/pages/PageManual/PageManual'),
          meta: { requiredAuth: true }
        },
        {
          path: '/admin/history',
          name: 'PageAccessHistoryCondition',
          //  load dynamic
          component: () => import(/* webpackChunkName: "accesshistory" */ '@/pages/PageAccessHistoryCondition/PageAccessHistoryCondition'),
          meta: { requiredAuth: true }
        },
        {
          path: '/admin/history/detail',
          name: 'PageAccessHistoryDetail',
          //  load dynamic
          component: () => import(/* webpackChunkName: "accesshistorydetail" */ '@/pages/PageAccessHistoryDetail/PageAccessHistoryDetail'),
          meta: { requiredAuth: true }
        },
        {
          path: '/static/term',
          name: 'PageStaticTerm',
          //  load dynamic
          component: () => import('@/pages/PageStaticTerm/PageStaticTerm')
        },
        {
          path: '/error',
          name: 'PageError',
          props: true,
          //  load dynamic
          component: () => import(/* webpackChunkName: "pageerror" */ '@/pages/PageError/PageError')
        },
        //  リダイレクト
        {
          path: '/move',
          redirect: { name: 'PageTop' }
        },
        //  404
        {
          path: '*',
          name: 'NotFound',
          //  load dynamic
          component: () => import(/* webpackChunkName: "notfound" */ '@/pages/NotFound/NotFound')
        }
      ]
    }
  ]
})
